module.exports = __webpack_public_path__ + "img/headSculpture1.27895321.png";